// The Holds register (rule 30) - the SPA's half: the API's row and totals types, and the words for them.
// The API's rules are api/src/domain/holdsRegister.ts; these labels mirror its WAITING_ON.

export type WaitingOn = 'D365_HOLD' | 'DECISION' | 'D365_RELEASE' | 'DRIFT' | 'DONE';

export interface RegisterRow {
  holdId: number;
  materialClass: 'RM' | 'FG';
  scope: 'BATCH' | 'PALLETS';
  item: string;
  itemName: string | null;
  batch: string;
  supplier: { account: string; name: string | null } | null;
  source: { kind: string; id: number | null };
  reason: string;
  ncrId: string;
  requestedByUpn: string;
  requestedAt: string;
  status: 'REQUESTED' | 'CONFIRMED' | 'RELEASE_REQUESTED' | 'RELEASED';
  waitingOn: WaitingOn;
  daysOpen: number;
  ageBucket: 'UNDER_3' | 'DAYS_3_TO_14' | 'OVER_14';
  releasedAt: string | null;
  lastSeen: { code: string | null; words: string; at: string | null } | null;
  value: { physical: number; asOf: string | null } | null;
}

export interface RegisterTotals {
  open: number;
  byClass: { RM: number; FG: number };
  over14: number;
  waitingOn: Record<WaitingOn, number>;
  valueHeld: { RM: number; FG: number; unknown: number };
  valueAsOf: string | null;
}

export interface RegisterPayload {
  rows: RegisterRow[];
  totals: RegisterTotals;
}

export const WAITING_LABEL: Record<WaitingOn, string> = {
  D365_HOLD: 'Hold to be set in D365',
  DECISION: 'QA decision',
  D365_RELEASE: 'Release to be done in D365',
  DRIFT: 'Taken off in D365 outside the app',
  DONE: 'Released',
};

export const CLASS_LABEL = { RM: 'Raw material', FG: 'Finished goods' } as const;
export const SCOPE_LABEL = { BATCH: 'Whole batch', PALLETS: 'Pallets (14-Q)' } as const;

/** "$4,286" - whole dollars; null is "not known", never $0 (rule 15). */
export function money(v: number | null | undefined): string {
  if (v === null || v === undefined) return 'not known';
  return `$${Math.round(v).toLocaleString('en-AU')}`;
}

/** "3.5 d", "14 h" under a day. */
export function daysText(d: number): string {
  return d < 1 ? `${Math.round(d * 24)} h` : `${Math.round(d * 10) / 10} d`;
}

/** The tile's value-held sentence: known total, and how many holds' value could not be read. */
export function valueHeldText(t: RegisterTotals): string {
  const known = t.valueHeld.RM + t.valueHeld.FG;
  const unknown = t.valueHeld.unknown;
  if (t.open === 0) return '$0';
  if (unknown === t.open) return 'not known';
  return unknown > 0 ? `${money(known)} + ${unknown} not known` : money(known);
}
